module.exports = __webpack_public_path__ + "static/media/AVI.857fd819.svg";